module.exports = __webpack_public_path__ + "img/27.abe9991a.jpg";